import Callout from '../../components/callout/Callout';
import {CharactersStore} from '../../stores';
import MetaTags from '../../components/common/MetaTags';
import Progression from '../../components/progression/Progression';
import PropTypes from 'prop-types';
import React from 'react';
import Swoosh from '../../components/swoosh/Swoosh';
import VisibilitySensor from 'react-visibility-sensor';
import {connectToStores} from 'epic-alt-utils/index';
import {generateRoutePath} from '@epic-core/common';
import {withLocalization} from '@epic-core/localization';

@connectToStores
class ProgressionView extends React.Component {
    static propTypes = {
        charactersData: PropTypes.object,
        getMessage: PropTypes.func
    };
    static getStores() {
        return [CharactersStore];
    }

    static getPropsFromStores() {
        return {
            charactersData: CharactersStore.getState()
        };
    }
    state = {
        active: false,
        activeProgression: ''
    }

    inView = (isVisible) => {
        if (isVisible) {
            this.setState({active: true});
        } else {
            this.setState({active: false});
        }
    };

    toggleProgression = (title) => {
        this.setState({activeProgression: title});
    }

    render() {
        const pageData = this.props.charactersData.data;
        const {subtext, challenge = {}, progression = {}, training = {}} = pageData;
        const headline = this.props.getMessage("epic.ut.progression.headline");
        const challengeTitle = this.props.getMessage("epic.ut.progression.challenge.title");
        const progressionTitle = this.props.getMessage("epic.ut.progression.progression.title");
        const trainingTitle = this.props.getMessage("epic.ut.progression.training.title");
        return (
            <VisibilitySensor
                onChange={this.inView}
                partialVisibility
                scrollCheck
                scrollDelay={10} >
                <div className="progression-view">
                    <MetaTags meta={{title: headline}} />
                    <Swoosh skew="right" color="red" active={this.state.active} />
                    <div className="progression-content">
                        <Callout
                            headline={headline}
                            description={subtext}
                            buttonText={this.props.getMessage("epic.ut.progression.cta")}
                            buttonLink={generateRoutePath('characters')}
                            align="left"
                            active={this.state.active}
                            dark
                        />
                        <div className="progression-list">
                            {progression.levels && 
                            <Progression
                                data={progression.levels} 
                                title={progressionTitle} 
                                key={progressionTitle} 
                                activeProgression={this.state.activeProgression} 
                                toggleProgression={this.toggleProgression} />}
                            {challenge.levels && 
                            <Progression 
                                data={challenge.levels} 
                                title={challengeTitle} 
                                key={challengeTitle} 
                                activeProgression={this.state.activeProgression} 
                                toggleProgression={this.toggleProgression} />}
                            {training.levels && 
                            <Progression 
                                data={training.levels} 
                                title={trainingTitle} 
                                key={trainingTitle} 
                                activeProgression={this.state.activeProgression} 
                                toggleProgression={this.toggleProgression} />}
                        </div>
                    </div>
                    
                </div>
            </VisibilitySensor>
        );
    }
}

export default withLocalization(ProgressionView)
